import { useState, useCallback } from 'react';
import { GetDDSAttachmentsForPatrol } from 'api/canguard/getDDSAttachments';
import { useNotificationProvider } from 'hooks';
import { useScheduleContext } from 'containers/pages/CANguard/context/ScheduleProvider';

const useFetchDDSFiles = (patrol: ScheduleAssignment) => {
	const [loadingFiles, setLoadingFiles] = useState(false);
	const { notifyError } = useNotificationProvider();
	const { updatePatrolInSchedule } = useScheduleContext();

	const fetchDDSFiles = useCallback(async () => {
		try {
			if (!patrol.comment_list_id) {
				console.error(
					'No comment list id, cannot fetch DDS attachments',
				);
				return;
			}
			if (!patrol.dds_files) {
				setLoadingFiles(true);
				const _ddsAttachments = await GetDDSAttachmentsForPatrol(
					patrol.comment_list_id,
				);
				updatePatrolInSchedule({
					...patrol,
					dds_files: _ddsAttachments,
				});
			}
		} catch {
			console.log('Error fetching DDS attachments');
			notifyError('Error fetching DDS attachments');
		} finally {
			setLoadingFiles(false);
		}
	}, [patrol, notifyError, updatePatrolInSchedule]);

	return { loadingFiles, fetchDDSFiles };
};

export default useFetchDDSFiles;
